module.exports = __webpack_public_path__ + "img/cmob.png";